export const RENDERCARDTYPE = {
  recommend: "recommend", // 推荐广告
  questionaire: "questionaire", //问卷
  similar: "similar", //相似素材卡片
  topicCollectionA: "topicCollectionA", //搜索结果页专题合集-样式优化实验组A
  allPinsBoard: "allPinsBoard", //全部采集的画板
  recommendTopicList: "recommendTopicList", //推荐专题列表
  artRecommend: "artRecommend", //art推荐素材卡片
  aiGameplay: "aiGameplay", // ai玩法卡片
  recommendMiddle: "recommendMiddle", // 腰部专题推荐
  boardOperation: "boardOperation", // 同在画板运营位
  sameBoardModule: "sameBoardModule", // 同在画板纵向布局模组
  recommendSearchWordsA: "recommendSearchWordsA", // 推荐搜索词样式A
  recommendSearchWordsB: "recommendSearchWordsB", // 推荐搜索词样式B
  pinDetailInfo: "pinDetailInfo", // 详情页信息卡片
  pinCardSkeleton: "pinCardSkeleton", // 单个Pin卡片骨架屏
  similarMaterial: "similarMaterial", // 相似商用素材卡片
  boardCardA: "boardCardA", // 单画板卡片（插入到瀑布流中）
  boardSwiper: "boardSwiper", // 推荐画板横向滚动卡片（固定在详情卡片下方）
};
